export default {
    current: '电流',
    load: '负荷',
    reactivePower: '无功功率',
    phaseVoltage: '相电压',
    powerFactor: '功率因数',
    electricDegree: '电度',//用电量
    electricDegree2: '电度2',
    standardCoal: '标准煤',
    electricTemperature: '温度',

    allSpring:'所有钻井',
    oneSpring:'某个钻井',
    oneDevice:'某个设备',
    latestOneMonth:'最近30天',
    year:'年',
    month: '月',
    day:'日'
}
